module.exports = __webpack_public_path__ + "img/2-sm.c3710255.jpg";